module.exports = __webpack_public_path__ + "assets/18e3ab5a86afe210d9bfcbb02207e61c.png";